import { MFEAddress, ValidationStatus } from './mfe-common.interfaces';

// Employment Status ENUM
export enum EmploymentStatus {
  EMPLOYED = 'E',
  SELF_EMPLOYED = 'SE',
  VANGUARD_EMPLOYED = 'VE',
  RETIRED = 'R',
  UNEMPLOYED = 'U',
  UNKNOWN = '',
}

// ===== SET DATA INTERFACES (input TO the MFE) =====

export interface EmploymentSetData {
  readonly homeAddresses: ReadonlyArray<MFEAddress>;
  readonly ownerIndex?: number;
  readonly employment: EmploymentFormData;
  readonly runValidation: boolean;
  readonly ownerFullName: string;
  readonly skipAssociationModal?: boolean;
}

export interface EmploymentFormData {
  readonly employmentStatus: EmploymentStatusFormData;
  readonly associations: EmploymentAssociationsFormData;
}

export interface EmploymentStatusFormData {
  readonly employmentStatus: EmploymentStatus;
  readonly employer: string;
  readonly occupation: string;
  readonly streetAddress: {
    readonly street: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
  };
}

export interface EmploymentAssociationsFormData {
  readonly spouse: boolean;
  readonly associated: boolean;
  readonly control: boolean;
  readonly none: boolean;
  readonly controlCompanyTicker?: Array<string>;
  readonly controlCompanyName?: Array<string>;
}

// ===== GET DATA INTERFACES (output FROM the MFE) =====

export interface EmploymentGetData {
  readonly employment: Partial<VgEmploymentState>;
  readonly validationStatus: ValidationStatus;
}

export interface VgEmploymentState {
  readonly associations: IEmploymentAssociationsState;
  readonly employmentStatus: IEmploymentStatusAndDetailsState;
}

export interface IEmploymentStatusAndDetailsState {
  readonly employmentStatus: EmploymentStatus;
  readonly employer: string;
  readonly occupation: string;
  readonly streetAddress?: MFEAddress;
}

export interface IEmploymentAssociationsState {
  readonly spouse: boolean;
  readonly associated: boolean;
  readonly control: boolean;
  readonly none: boolean;
  readonly controlCompanyTicker: ReadonlyArray<string>;
  readonly controlCompanyName: ReadonlyArray<string>;
  readonly continueConfirmActionCalled?: boolean;
  readonly modalVisibility?: ModalVisibility;
}

// Modal visibility tracking
export interface ModalVisibility {
  readonly controlPersonUpdateInfo?: boolean;
  readonly finraWarning?: boolean;
  readonly controlPersonCheck?: boolean;
  readonly employerNameSuggest?: boolean;
}

// Extended EmploymentGetData with modal state
export interface EmploymentGetDataWithModals extends EmploymentGetData {
  readonly modalVisibility?: ModalVisibility;
}
